export default {"src":"/_next/static/media/RO.25d05ae2.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};